export default "__VITE_ASSET__CuLnPqfg__"